export default __webpack_public_path__ + "static/media/class.70dbecc8.png";